module.exports = __webpack_public_path__ + "static/assets/ffc0066fd232bd05c8eafbd5fe7114c3.svg";